import { render, staticRenderFns } from "./COrganization.vue?vue&type=template&id=7ff21fde&scoped=true&"
import script from "./COrganization.vue?vue&type=script&lang=js&"
export * from "./COrganization.vue?vue&type=script&lang=js&"
import style0 from "./COrganization.vue?vue&type=style&index=0&id=7ff21fde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff21fde",
  null
  
)

export default component.exports